import { Link } from "react-router-dom";
import { SITE, PARTNERS } from "@/config/site";
import logoWhite from "@/assets/villa-rosa-text-icon-white.svg";
import styles from "./Footer.module.css";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.lead}`}>
        <p className={`eyebrow eyebrow--rule ${styles.leadEyebrow}`}>
          Fallbrook · California
        </p>
        <h2 className={styles.leadTitle}>
          Let&rsquo;s plan something
          <br />
          unforgettable.
        </h2>
        <div className={styles.leadCtas}>
          <Link to="/book-an-event" className="btn btn--primary">
            Plan an event
          </Link>
          <Link to="/book-a-stay" className="btn btn--outline-light">
            Book a stay
          </Link>
        </div>
      </div>

      <div className={`container ${styles.grid}`}>
        <div className={styles.brandCol}>
          <img className={styles.logo} src={logoWhite} alt="Villa Rosa" width={210} height={48} />
          <p className={styles.blurb}>
            A 30-acre vacation &amp; event estate in the hills of Fallbrook,
            California — built to entertain, ready for relaxation.
          </p>
        </div>

        <nav className={styles.col} aria-label="Footer">
          <h4 className={styles.colTitle}>Explore</h4>
          <Link to="/book-a-stay">Book a Stay</Link>
          <Link to="/book-an-event">Book an Event</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Book With</h4>
          <a href={PARTNERS.airbnb} target="_blank" rel="noopener noreferrer">
            Airbnb
          </a>
          <a href={PARTNERS.vrbo} target="_blank" rel="noopener noreferrer">
            Vrbo
          </a>
          <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Location</h4>
          <p className={styles.muted}>
            Fallbrook, California
            <br />
            North San Diego County
          </p>
        </div>
      </div>

      <div className={`container ${styles.bottom}`}>
        <span>© {year} Villa Rosa. All rights reserved.</span>
        <span className={styles.muted}>Vacation &amp; event rental · Fallbrook, CA</span>
      </div>
    </footer>
  );
}
